import { Constraint, ConstraintParameter } from '../constraints';

export class MandatoryArticleConstraint implements Constraint {
  static type = 'mandatory';
  static disabled = false;
  static supportsMultiple = false;
  type = 'mandatory';
  disabled = false;
  configurable = true;
  mandatory = true;
  supportsNegation = false;
  negated = false;
  priority = 1;
  parameters = {
    'isMandatory': {
      type: 'boolean',
      disabled: false,
      description: true,
      value: true
    } as ConstraintParameter
  };
}
